const IMAGEURL = 'https://astrobhagya.s3.ap-south-1.amazonaws.com';
export default IMAGEURL; 